<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="pagibig-contributions" color="white"></help-link>
                    <v-btn dark icon v-show="!loading&&pagibig_details.length" @click="generateExcel" :loading="loading_xls" title="Export to Excel">
                        <v-icon>fas fa-file-excel</v-icon>
                    </v-btn>
                    <v-menu left v-if="!loading" v-model="menu_status" offset-y :disabled="paidStatus||!hasEditRights">
                        <template v-slot:activator="{ on }">
                            <v-btn v-show="paidStatus" color="green" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;&nbsp;Paid&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="!paidStatus" color="orange" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;&nbsp;UnPaid&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-show="hasEditRights" :key="1" @click="setToPaid" title="Set status to Paid">
                                <v-list-tile-title small>Paid</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>

            <v-expansion-panel v-if="!loading" v-model="panel" expand class="mt-5">
                <!-- SUMMARY -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-8px;':''">SUMMARY</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elevation-1 transparent"> 
                        <v-card-text v-if="!loading" >
                            <v-layout row wrap> 
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Calendar Year :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{pagibig_summary.fiscalYear}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Month : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{pagibig_summary.monthName}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout v-if="pagibig_summary.paidOn" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Paid On : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{pagibig_summary.paidOn | moment('MMM DD, YYYY')}}
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Coverage : 
                                        </v-flex>
                                        <v-flex xs8 class="text-xs-left">
                                            <div v-for="(item,key) in pagibig_summary.coverage" :key="key">
                                                <b>{{ getCutoffCoverageDescription(item.cutoffStart, item.cutoffEnd) }}</b>
                                            </div>
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- DETAILS -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-8px;':''">DETAILS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-data-table
                        :headers="isMobile ? [] : headers"
                        :items="pagibig_details"
                        :loading="loading"
                        :rows-per-page-items="rowsPerPageItems"
                        :pagination.sync="paginationSync"
                        :hide-headers="isMobile"
                    >
                        <template v-slot:items="props">

                            <!-- mobile view -->
                            <tr v-if="isMobile">
                                <td :colspan="headers.length" class="pa-1">
                                    <v-card class="elevation-1">
                                        <v-layout row wrap align-center class="section-layout-mobile">
                                            <v-flex xs12 class="text-xs-left mt-5 mb-2">
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">EmployeeId</div>
                                                        <div>{{props.item.employeeId}}</div>
                                                    </v-flex>
                                                     <v-flex xs8>
                                                        <div class="caption grey--text text--darken-1">Employee</div>
                                                        <div>{{props.item.firstName}} {{props.item.lastName}}</div>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                     <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Pagibig No.</div>
                                                        <div>{{props.item.pagibigNo}}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Employee Contributions</div>
                                                        <div>{{numFormat.formatNumber(props.item.totalEmployeeContribution)}}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Employer Contributions</div>
                                                        <div>{{numFormat.formatNumber(props.item.totalEmployerContribution)}}</div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                </td>
                            </tr>

                            <!-- desktop view -->
                            <tr v-else>
                                <td>{{props.item.employeeId}}</td>
                                <td>{{props.item.firstName}}</td>
                                <td>{{props.item.lastName}}</td>
                                <td>{{props.item.pagibigNo}}</td>
                                <td>
                                    <div class="text-xs-right">
                                        {{numFormat.formatNumber(props.item.totalEmployeeContribution)}}
                                    </div>
                                </td>
                                <td>
                                    <div class="text-xs-right">
                                        {{numFormat.formatNumber(props.item.totalEmployerContribution)}}
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table> 
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import payrollApi from '@/api/payroll'
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort } from '@/helpers/user-prefs'
import { hasEditRights } from '@/helpers/access-permissions'
import { getCutoffCoverageDescription } from '@/helpers/cutoff-format'

export default {     
    name: 'PagibigContributionDetails',
    metaInfo: {
        title: 'Pagibig ContributionDetails',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View Pagibig Contributions details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            numFormat,
            rowsPerPageItems,
            getCutoffCoverageDescription,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Employee Id',align: 'left',value: 'employeeId', width: '10%', sortable:true},
                {text: 'First Name',align: 'left',value: 'firstName',  width: '20%', sortable:true},
                {text: 'Last Name',align: 'left',value: 'lastName',  width: '20%', sortable:true},
                {text: 'Pagibig Number',align: 'left',value: 'cutoffEnd', width: '20%', sortable:true},
                {text: 'Total Employee Contributions',align: 'right',value: 'totalEmployeeContribution', width: '20%', sortable:true},
                {text: 'Total Employer Contributions',align: 'right',value: 'totalEmployerContribution', width: '20%', sortable:true},
            ],
            error: false,
            errorMessage: '',
            loading: false,
            loading_status: false,
            loading_xls: false,
            pagibig_summary: null,
            pagibig_details: [],
            menu_status: false,
            panel: [true, true],
        }
    },
    methods: { 
        async setToPaid() {
            try {
                this.loading_status = true
                var data = {
                    fiscalYear: this.selectedFiscalYear,
                    month: this.selectedMonth
                }
                const response = await payrollApi.setPagibigContributionsPaid(data)
                if (response && response.status == 200) {
                    await this.getDetails(false)
                }
                this.loading_status = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        async getDetails(show_loading) {
            try {
                this.loading = show_loading
                var data = {
                    fiscalYear: this.selectedFiscalYear,
                    month: this.selectedMonth
                }
                const response = await payrollApi.getPagibigContributionsDetails(data)
                if (response && response.status == 200) {
                    this.pagibig_summary = response.data.summary
                    this.pagibig_details = response.data.details
                }

                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async generateExcel() {
            try {
                this.loading_xls = true
                
                var data = {
                    fiscalYear: this.selectedFiscalYear,
                    month: this.selectedMonth
                }
                const response = await payrollApi.getPagibigContributionsXls(data)
                if (response && response.status == 200) {
                    var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
                    var link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = `Pagibig-Contributions-${this.pagibig_summary.monthName}-${this.pagibig_summary.fiscalYear}.xlsx`
                    link.click()
                }

                this.loading_xls = false
            }catch(error){
                his.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getDetails(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Pagibig Contributions Details'
        })

        this.getDetails(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        selectedFiscalYear() {
            return this.$route.params.fiscalYear
        },
        selectedMonth() {
            return this.$route.params.month
        },
        paidStatus() {
            if (!this.loading) return this.pagibig_summary.paidOn != null
        },
        companyIdStr() {
            return this.$store.state.companyId
        },
        pageQueryId() {
            return `pagibig-${this.companyIdStr}-${this.selectedFiscalYear}-${this.selectedMonth}`
        },
        commentsData() {
            if (this.pagibig_summary) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.pagibig,
                    notificationTypeId: notificationTypes.pagibig_contributions
                }
            }
        },
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 50px 0px 50px;
}
.section-layout-mobile {
    padding:0px 23px 0px 23px;
}
</style>